import pb from "../../utils/pocketbase";
import crypto from 'crypto-js';
import axiosInstance from "../../utils/axios";
pb.autoCancellation(false);


/////////////////


const serverDate = localStorage.getItem('date');

// const parseValue = JSON.parse(getValue);
// console.log(parseValue[0].Season);


// const record = await pb.collection('transactions').create(data);
export const getCatalogue = async () => {

  try {

    const response = await axiosInstance.get('inventory/getData.php');
 
    return response.data
} catch (error) {
    console.error('Error:', error);
}

};

export const getBidderinvoice = async ({timestamp,api_key,timestamps,record}) => {
  try {
    const records = await pb.collection('bidderinvoice').getFullList({
      headers: {
        'time_stamp': timestamp,
        'created': timestamps,
        'api_key': api_key
      },
      expand:"bidder_current,bidder_current.reference,Warehose",
      filter:`brokersID="${pb.authStore.model.id}" && Sale_number=${record.sale} && Season="${record.season}"`
  });
    return records;
  } catch (error) {
    console.log(error);
  }
};


export const addInvenetory = async ({ cart, paidValue,discountValue,loadUnloadValue }) => {

   const inv_id = 'INV' + Date.now().toString().slice(-4);
   const additional_data = `${discountValue}-${loadUnloadValue}-${paidValue}`;

try {
  // console.log(filteredArray);
  const response = await axiosInstance.post('/inventory/createData.php', {
    cart: cart,
    inv_id: inv_id,
    additional_data:additional_data
    // Include inv_id in the request data
  });



  if (parseInt(discountValue) !== 0) {
   
    // Create transaction for discountValue
    const payItem = {
        "inv_id": inv_id,
        "e_date": cart[0].e_date,
        "ac_id": 2,
        "remarks": cart[0].ac_id,
        "payment": discountValue,
        "receive": 0,
        "sell_type": 'INVTRANSACTION',
    };
    const recItem = {
      "inv_id": inv_id,
      "e_date": cart[0].e_date,
      "ac_id": cart[0].ac_id,
      "remarks": "Discount",
      "payment": 0,
      "receive": discountValue,
      "sell_type": 'INVTRANSACTION'
  };
  
   await axiosInstance.post('/transactions/createInvdata.php', payItem);  
  await axiosInstance.post('/transactions/createInvdata.php', recItem);
  } 
  
  if (parseInt(loadUnloadValue) !== 0) {
   

    // Create transactions for loadUnloadValue
    const payItem = {
        "inv_id": inv_id,
        "e_date": cart[0].e_date,
        "ac_id": 3,
        "remarks": cart[0].ac_id,
        "payment": loadUnloadValue,
        "receive": 0,
        "sell_type": 'INVTRANSACTION',
    };
    const recItem = {
        "inv_id": inv_id,
        "e_date": cart[0].e_date,
        "ac_id": cart[0].ac_id,
        "remarks": 'Load/Unload',
        "payment": 0,
        "receive": loadUnloadValue,
        "sell_type": 'INVTRANSACTION',
        "posted": pb.authStore.model.expand.reference.id
    };
    
   await axiosInstance.post('/transactions/createInvdata.php', payItem);  
  await axiosInstance.post('/transactions/createInvdata.php', recItem);
  } 
  
  if (parseInt(paidValue) !== 0 && cart[0].bill_type==="CREDIT" ) {
    // Create transaction for paidValue
    const recItem = {
        "inv_id": inv_id,
        "e_date": cart[0].e_date,
        "ac_id": cart[0].ac_id,
        "remarks": 'Cash',
        "payment": 0,
        "receive": paidValue,
        "sell_type": 'INVTRANSACTION'
    };
    
  await axiosInstance.post('/transactions/createInvdata.php', recItem);
  }





  return response.data
} catch (error) {
  console.error('Error:', error);
}
};
//fetch a selected invoice data
export const fetchSelected = async (id) => {

  try {
    const response = await axiosInstance.get(`/inventory/selectData.php?id=${id}`);

 return response.data;
} catch (error) {
    console.error('Error:', error);
}
 
};


export const updateSelecetedinvoice = async ({ cart, id, paidValue, discountValue, loadUnloadValue }) => {

  const inv_id =id;

  const additional_data = `${discountValue}-${loadUnloadValue}-${paidValue}`;
  try {
    // console.log(filteredArray);
    const response = await axiosInstance.post('/inventory/updateData.php', {
      cart: cart,
      inv_id: id,
      additional_data:additional_data
      // Include inv_id in the request data
    });

    
  if (parseInt(discountValue) !== 0) {
    // Create transaction for discountValue
    const payItem = {
        "inv_id": inv_id,
        "e_date": cart[0].e_date,
        "ac_id": 2,
        "remarks": cart[0].ac_id,
        "payment": discountValue,
        "receive": 0,
        "sell_type": 'INVTRANSACTION',
    };
    const recItem = {
      "inv_id": inv_id,
      "e_date": cart[0].e_date,
      "ac_id": cart[0].ac_id,
      "remarks": "Discount",
      "payment": 0,
      "receive": discountValue,
      "sell_type": 'INVTRANSACTION'
  };
  
   await axiosInstance.post('/transactions/createInvdata.php', payItem);  
  await axiosInstance.post('/transactions/createInvdata.php', recItem);
  } 
  
  if (parseInt(loadUnloadValue) !== 0) {
    // Create transactions for loadUnloadValue
    const payItem = {
        "inv_id": inv_id,
        "e_date": cart[0].e_date,
        "ac_id": 3,
        "remarks": cart[0].ac_id,
        "payment": loadUnloadValue,
        "receive": 0,
        "sell_type": 'INVTRANSACTION',
    };
    const recItem = {
        "inv_id": inv_id,
        "e_date": cart[0].e_date,
        "ac_id": cart[0].ac_id,
        "remarks": 'Load/Unload',
        "payment": 0,
        "receive": loadUnloadValue,
        "sell_type": 'INVTRANSACTION',
        "posted": pb.authStore.model.expand.reference.id
    };
    
     await axiosInstance.post('/transactions/createInvdata.php', payItem);  
  await axiosInstance.post('/transactions/createInvdata.php', recItem);
  } 
  
  if (parseInt(paidValue) !== 0) {
    // Create transaction for paidValue

    const recItem = {
        "inv_id": inv_id,
        "e_date": cart[0].e_date,
        "ac_id": cart[0].ac_id,
        "remarks": 'Cash',
        "payment": 0,
        "receive": paidValue,
        "sell_type": 'INVTRANSACTION'
    };
    
  await axiosInstance.post('/transactions/createInvdata.php', recItem);
  }


    
    return response.data
  } catch (error) {
    console.error('Error:', error);
  }
};



// export const updateSelecetedinvoice = async ({invoice_details,cart}) => {
//   console.log(cart);
//   const data = {
//     "date": "test",
//     "vehicle": "test",
//     "factory": "kxtmrstrwcvqas4",
//     "broker": "kxtmrstrwcvqas4",
//     "invoice": "test",
//     "rack": "test",

// };
//   try {

//     const record = await pb.collection('inventory').update('1wa0a5i0vw777p9', data);
//     console.log(record);
//   return record;
//   } catch (error) {
//     console.log(error);
//   }

//   };


export const deleteInvoice = async (id) => {

  try {
    const response = await axiosInstance.delete(`/inventory/deleteData.php?id=${id}`);
return response
} catch (error) {
    console.error('Error:', error);
}

 
};